import { render, staticRenderFns } from "./CurrentSubscriptionDetails.vue?vue&type=template&id=7a4706b6&scoped=true&"
import script from "./CurrentSubscriptionDetails.vue?vue&type=script&lang=js&"
export * from "./CurrentSubscriptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4706b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
